import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  exchangeSchoolYearPath,
  nextYearClassesPath,
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  fetchTeachers,
  fetchClass,
  deleteClass,
  IClassParam,
  updateClass,
  UPDATE_CLASS_SUCCESS_MESSAGE,
  DELETE_CLASS_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import Toast from "../../../molecules/Toast";
import ClassForm from "../../../templates/manager/ClassForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useDidMountEffect from "../../../hooks/useDidMountEffect";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export default (props: { match: { params: { id: string } } }) => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const { nextYear } = useCurrentYear();
  const id = parseInt(props.match.params.id, 10);

  React.useEffect(() => {
    if (
      state.success_message === UPDATE_CLASS_SUCCESS_MESSAGE ||
      state.success_message === DELETE_CLASS_SUCCESS_MESSAGE
    ) {
      Toast.success(state.success_message);
      dispatch(clearSuccessMessage());
      history.push(nextYearClassesPath);
    }
  }, [history, dispatch, state.success_message]);

  useDidMountEffect(() => {
    if (state.error) {
      Toast.error(state.error);
    }
  }, [dispatch, state.error]);

  const updateClassFunc = React.useCallback(
    (cls: IClassParam) => {
      dispatch(peep(updateClass(cls)));
    },
    [dispatch, peep],
  );

  const deleteClassFunc = React.useCallback(
    (id: number) => {
      dispatch(peep(deleteClass(id)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchTeachers());
    dispatch(fetchClass(id));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, id]);

  const teacher_ids = React.useMemo(
    () => state.teachers.filter(t => t.class_ids.includes(id)).map(t => t.id),
    [state.teachers, id],
  );

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.exchangeSchoolYear, to: exchangeSchoolYearPath },
          {
            title: `${titles.nextYearClasses} (${nextYear}年度)`,
            to: nextYearClassesPath,
          },
        ]}
        currentTitle={`${titles.editNextYearClass} (${nextYear}年度)`}
      />
      <ClassForm
        title={`${titles.editNextYearClass} (${nextYear}年度)`}
        calling={calling}
        cls={state.classes[0]}
        teacher_ids={teacher_ids}
        teachers={state.teachers}
        error={state.error}
        isNextYear={true}
        upsertClass={updateClassFunc}
        deleteClass={deleteClassFunc}
      />
    </div>
  );
};
